// FormField component for UI Component Library
// Created as part of ENG2-1691: Phase 3 - Ticket 3.3

import React from 'react'
import { Box, FormHelperText } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tokens } from '../../../styles/tokens'
import { FormFieldProps } from './form-field.types'

// Styled container
const FieldContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
})

// Styled label
const FieldLabel = styled('label')({
  fontSize: 13,
  fontWeight: 500,
  color: tokens.colors.grey[700],
})

// Styled required indicator
const RequiredIndicator = styled('span')({
  color: tokens.colors.error[500],
  marginLeft: 2,
})

// Styled helper/error text
const StyledHelperText = styled(FormHelperText, {
  shouldForwardProp: (prop) => prop !== 'isError',
})<{ isError?: boolean }>(({ isError }) => ({
  fontSize: 12,
  marginTop: 4,
  marginLeft: 0,
  color: isError ? tokens.colors.error[500] : tokens.colors.grey[500],
}))

export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  error,
  helperText,
  required = false,
  sx,
  className,
}) => {
  const displayHelperText = error || helperText

  return (
    <FieldContainer sx={sx} className={className}>
      <FieldLabel>
        {label}
        {required && <RequiredIndicator>*</RequiredIndicator>}
      </FieldLabel>
      {children}
      {displayHelperText && (
        <StyledHelperText isError={!!error}>
          {displayHelperText}
        </StyledHelperText>
      )}
    </FieldContainer>
  )
}

FormField.displayName = 'FormField'

export default FormField
export type { FormFieldProps } from './form-field.types'
